export default "__VITE_ASSET__BpFimik$__"